import { LabelingTypeEnum } from 'src/types';

type GetModeDisplayLabelTypes = {
  value?: string | number;
  name?: string;
  fallbackValue?: string;
  // Only set for controllers with multiple mode tags, where the tag name prefixes the option.
  tagDisplayName?: string;
  labellingType?: LabelingTypeEnum;
  // Canonical mode string, returned when there is no labelling type to re-render with.
  fallback: string;
};

// Single place where a mode value is turned into what the user sees, so the controller
// widget and the controller modal stay in sync.
export const getModeDisplayLabel = ({
  value,
  name,
  fallbackValue,
  tagDisplayName,
  labellingType,
  fallback,
}: GetModeDisplayLabelTypes) => {
  const prefix = tagDisplayName ? `${tagDisplayName} - ` : '';
  // A user defined value without a name falls back to `fallbackValue` as its label, so
  // VALUE_LABEL keeps the value instead of rendering the value on its own.
  const label = name || fallbackValue || '';

  switch (labellingType) {
    case LabelingTypeEnum.VALUE:
      return `${prefix}${value}`;
    case LabelingTypeEnum.LABEL:
      return `${prefix}${label}`;
    case LabelingTypeEnum.VALUE_LABEL:
      return `${prefix}${label ? `${value} - ${label}` : value}`;
    default:
      return fallback;
  }
};
